import AxiosControl from '../components/axios/AxiosControl'

export const CHECKING_GET_STATUS = 'CHECKING_GET_STATUS'
export const CHECKING_RECORD = 'CHECKING_RECORD'
export const CHECKING_SET_LOADING = 'CHECKING_SET_LOADING'
export const CHECKING_CLEAR = 'CHECKING_CLEAR'

export const getCheckingStatus = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: CHECKING_SET_LOADING, payload: true })
            const api = AxiosControl()
            const res = await api.get('/api/teacher/sdontime/status', {
                headers: { auth: localStorage.getItem('jwt') }
            })
            dispatch({
                type: CHECKING_GET_STATUS,
                payload: {
                    connected: res.data.connected,
                    checking: res.data.checking,
                    summary: res.data.summary
                }
            })
        } catch (error) {
            dispatch({
                type: CHECKING_GET_STATUS,
                payload: { connected: false, checking: null, summary: null }
            })
        } finally {
            dispatch({ type: CHECKING_SET_LOADING, payload: false })
        }
    }
}

export const recordChecking = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: CHECKING_SET_LOADING, payload: true })
            const api = AxiosControl()
            const res = await api.post('/api/teacher/sdontime/record', {}, {
                headers: { auth: localStorage.getItem('jwt') }
            })
            dispatch({
                type: CHECKING_RECORD,
                payload: {
                    action: res.data.action,
                    checking: res.data.checking,
                    summary: res.data.summary,
                    seconds: res.data.seconds,
                    message: res.data.message
                }
            })
            return res.data
        } catch (error) {
            throw error.response?.data || { message: 'Error al registrar fichaje' }
        } finally {
            dispatch({ type: CHECKING_SET_LOADING, payload: false })
        }
    }
}

export const syncSdontime = () => {
    return async (dispatch) => {
        try {
            const api = AxiosControl()
            const res = await api.post('/api/teacher/sdontime/sync', {}, {
                headers: { auth: localStorage.getItem('jwt') }
            })
            return res.data
        } catch (error) {
            throw error.response?.data || { message: 'Error al sincronizar con SDOntime' }
        }
    }
}
